import type {Locale} from '@aboutyou/config';
import {Log} from '@aboutyou/mlm';

type Config = {
  hostname: string;
  url: string;
  transactionName: string;
  locale?: Locale;
  traceId: string;
  enableRealUserMode: boolean;
  enableBotMode: boolean;
  isBotRequest: boolean;
  requestMethod: string;
};

interface EnhancerParams {
  /**
   * Will modify the transaction names, so that we can distinguish between different route events, e.g. redirects and 404 pages that happen during the evaluation of this transaction
   **/
  modifier?: 'notfound' | 'redirect';
  statusCode?: number;
  [key: string]: string | undefined | number | boolean;
}

export const logTransaction = ({
  hostname,
  url,
  transactionName: transactionNameProp,
  locale,
  traceId,
  enableRealUserMode,
  enableBotMode,
  isBotRequest,
  requestMethod,
}: Config) => {
  if (!locale) {
    return () => {};
  }

  let transactionName: string = transactionNameProp;

  if (process.env.NODE_ENV !== 'test') {
    Log.transact(transactionName, {
      // deprecated, should be removed after a graceful transition period
      enableRealUserMode,
      realUserMode: enableRealUserMode,
      botMode: enableBotMode,
      isBotRequest,
      traceId,
      url,
      hostname,
      locale,
      uptime: String(process.uptime()),
      method: requestMethod,
    });
  }

  return function enhanceTransaction(params: EnhancerParams) {
    if (params.modifier) {
      transactionName = `${params.modifier}/${transactionName}`;
    }
    const transactionParams: {[key: string]: string} = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        transactionParams[key] = String(value);
      }
    });
    if (process.env.NODE_ENV !== 'test') {
      Log.transact(transactionName, transactionParams);
    }
  };
};
